import React, { useContext, useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Button, Table, Divider } from 'antd';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import { numberFormatter, totalInFormatter, totalOutFormatter } from '../../../components/formatters/numberFormatter';
import ComponentViewSession from '../../../components/print/printViewSession';
import { useReactToPrint } from 'react-to-print';
import exportToExcel from '../../../components/export/excel'; 



const ViewidRow = (props) => {

  const { api, userData, settingData, mainCurrency, currencyData, defaultCurrency } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;


  const { showModal, toggleModal, idRow, journalVoucher } = props;
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [validated, setValidated] = useState(false);  


  const isUsingMainCurrency = defaultCurrency.id == mainCurrency.id ? true : false;

  const secondaryCurrency = currencyData?.find(option => option.id === settingData.secondaryCurrencyId) || null;
  const [showPrintComponent, setShowPrintComponent] = useState(false); 
  const [exportLoading, setExportLoading] = useState(false);


  

  const columns = [
    { title: 'ID', dataIndex: 'id' },
    { title: 'Type', dataIndex: 'type' },
    {
      title: 'In',
      dataIndex: isUsingMainCurrency ? 'totalDebit' : 'secondaryTotalDebit',
      render: totalInFormatter,
    },
    {
      title: 'Out ',
      dataIndex: isUsingMainCurrency ? 'totalCredit' : 'secondaryTotalCredit',
      render: totalOutFormatter,
    },
  ]

  


    // Ref for the printable content
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,

  });
  
  const handlePrintStatus = () => {
    setShowPrintComponent(true);
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  function formatTotalIn(value, isDebit) {
  if (!isDebit) return numberFormatter(value);
  return '';
}

function formatTotalOut(value, isDebit) {
  if (isDebit) return numberFormatter(value);
  return '';
}


  

// Function to prepare data for Excel export
const prepareExcelData = () => {
  // Main data rows
  const transformedData = idRow?.journalVouchers?.map(item => ({
    id: item.id,
    type: item.type,
    in: formatTotalIn(
      isUsingMainCurrency ? item.totalDebit : item.secondaryTotalDebit,
      item.isDebit
    ),
    out: formatTotalOut(
      isUsingMainCurrency ? item.totalCredit : item.secondaryTotalCredit,
      item.isDebit
    ),
  })) || [];



  return {
    transformedData,

    title: `Session_${idRow?.id}_Report`,
  };
};

// Function to handle Excel export
const handleExportExcel = () => {
  setExportLoading(true);
  try {
    const excelData = prepareExcelData();
    if (!excelData.transformedData || excelData.transformedData.length === 0) {
      toast.error('No data available to export');
      return;
    }
    exportToExcel(excelData, excelData.title);
  } catch (error) {
    toast.error('Failed to export to Excel');
    console.error('Export error:', error);
  } finally {
    setExportLoading(false);
  }
};



  return (
    <Modal show={showModal} backdrop="static" size={'lg'} keyboard={false} onHide={toggleModal}
      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
      <Modal.Header style={{ display: 'flex', justifyContent: 'center', background: "#23576a" }}>
        <Modal.Title style={{ color: "white" }} >View Session</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <>
          <Row>
            <Col md={3}>
              <span style={{ fontWeight: 'bold' }}>
                OpenedAt:
              </span>
            </Col>
            <Col md={9}>
              {dateTableFormatter(idRow?.openedAt)}
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <span style={{ fontWeight: 'bold' }}>
                ClosedAt:
              </span>
            </Col>
            <Col md={9}>
              {dateTableFormatter(idRow?.closedAt)}
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={3}>
              <span style={{ fontWeight: 'bold' }}>
                Opening Balance:
              </span>
            </Col>
            <Col md={9}>
              {numberFormatter( isUsingMainCurrency ? idRow?.openingBalance : idRow?.secondaryOpeningBalance)}
            </Col>
          </Row>

          <Row className="mb-4">
            <Table columns={columns} dataSource={idRow?.journalVouchers} pagination={false} />
          </Row>

          <Row className="mb-4">
            <Col md={6}>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold' }}>
                Balance:
              </span>
            </Col>
            <Col md={2}>
              <span style={{ fontWeight: 'bold', color: '#008000' }}>
                {numberFormatter(isUsingMainCurrency ? idRow?.balance : idRow?.secondaryBalance)}
              </span>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={6}>
            </Col>
            <Col md={3}>
              <span style={{ fontWeight: 'bold' }}>
                Variance:
              </span>
            </Col>
            <Col md={2}>
              <span style={{ fontWeight: 'bold', color: '#008000' }}>
                {numberFormatter(isUsingMainCurrency ? idRow?.variance : idRow?.secondaryVariance)}
              </span>
            </Col>
          </Row>
        </>

        <div className="modal-footer" style={{ justifyContent: 'center' }}>
          <Button type="primary" size="large" onClick={toggleModal} danger>Close</Button>
          <Button type="default" size="large" onClick={handlePrintStatus}>Print</Button>
           <Button 
            type="primary" 
            size="large" 
            onClick={handleExportExcel}
            loading={exportLoading}
          >
            Export Excel
          </Button>
        </div>

        
      
       
      </Modal.Body>


      {showPrintComponent && (
        <div style={{ display: 'none' }}>
          <ComponentViewSession
            ref={printRef}
            idRow={idRow}
            isUsingMainCurrency={isUsingMainCurrency}
            columns={columns}
          />
        </div>
      )}

    </Modal>
  )
}


export default ViewidRow;